import { useMemo } from 'react';

import { useLocationFishGroupsController_timeline } from '@/services/hooks';

import { mapSiteTimelineToDomain } from './siteTimeline.mappers';
import type { SiteTimelineScope, UseGetSiteTimelineResult } from './siteTimeline.types';
import { siteTimelineQueryParams } from './siteTimelineQuery';

/**
 * The site board's read model for one stocking cycle, or for the site's groups that belong to
 * no cycle: stays, events, bioscope coverage and lineage, in one call. Disabled until a scope
 * is picked.
 */
export const useGetSiteTimeline = (
    clientId: number,
    locationId: number,
    scope: SiteTimelineScope | null
): UseGetSiteTimelineResult => {
    const query = useLocationFishGroupsController_timeline(
        clientId,
        locationId,
        siteTimelineQueryParams(scope),
        { enabled: scope !== null }
    );

    const data = useMemo(
        () => (query.data?.data ? mapSiteTimelineToDomain(query.data.data) : null),
        [query.data?.data]
    );

    return {
        data,
        isLoading: scope !== null && query.isLoading,
        isFetching: query.isFetching,
        isFetched: query.isFetched,
        error: query.error,
        refetch: query.refetch,
    };
};
